import { FunctionComponent } from "react";
import { Icon } from "./types";
import { cn } from "../../utils/cn";

export interface CircleIconProps {
  className?: string;
  icon: Icon;
  size?: "xs" | "sm" | "md" | "lg" | "2xl";
}

/**
 *
 */
export const CircleIcon: FunctionComponent<CircleIconProps> = ({
  className,
  icon: ComponentIcon,
  size,
}) => {
  size = size || "md";
  const sizesMap: any = {
    lg: ["p-4", "h-10"],
    md: ["p-3", "h-7"],
    sm: ["p-2", "h-5"],
    xs: ["p-1", "h-2"],
    "2xl": ["p-16", "h-32"],
  };
  return (
    <div
      className={cn(
        `${sizesMap[size][0]} grid place-content-center rounded-full`,
        className,
      )}
    >
      <ComponentIcon className={`${sizesMap[size][1]} `} />
    </div>
  );
};
